// frontend/src/utils/apiYoutube.js
// El reproductor de YouTube con control (IFrame Player API) para la pantalla informativa: con él
// se puede pausar el video y saber cuándo termina para pasar al siguiente de la cola. Va aparte de
// youtube.js para que los tests lo reemplacen por un reproductor falso.

const URL_API = 'https://www.youtube.com/iframe_api';

let promesaApi = null;

/**
 * Carga el script de YouTube una sola vez y devuelve window.YT cuando está listo. Si el script no
 * carga (sin internet), la promesa falla y el próximo llamado vuelve a intentar.
 */
export function cargarApiYoutube() {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (promesaApi) return promesaApi;

    promesaApi = new Promise((resolve, reject) => {
        // YouTube avisa llamando a esta función global; se encadena por si otra parte la usa.
        const avisoAnterior = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
            if (typeof avisoAnterior === 'function') avisoAnterior();
            resolve(window.YT);
        };

        const script = document.createElement('script');
        script.src = URL_API;
        script.async = true;
        script.onerror = () => {
            promesaApi = null;
            script.remove();
            reject(new Error('No se pudo cargar el reproductor de YouTube.'));
        };
        document.head.appendChild(script);
    });
    return promesaApi;
}
